import React,{useState} from "react";
import BackToHomeLink from "../../components/BackToHomeLink";
import Container from "../../components/Container";
import Content from "../../components/Content";
import Layout from "../../components/Layout";
import { SUPPORT_EMAIL } from "../../utils/constants";
import { useLocation } from "react-router-dom"
import ServiceNow from '../../pages/ServiceNow/ServiceNow'
import getVectorImage from '../../utils/getVectorImage'
const PermissionsIssue = () => {
const location = useLocation()

const [showIncidentModal, setShowIncidentModal] = useState(false)

  const handleReportIssueClick = (e) => {
    e.preventDefault()
    setShowIncidentModal((prev) => !prev)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      setShowIncidentModal((prev) => !prev)
    }
  }

  const handleClose = () => {
    setShowIncidentModal(false)
  }
const path = location.pathname.replace('/' , ' ')
  return (
  <Layout>
    <Container>
      <Content>
        <h1> <span> {getVectorImage('warning', '30px', '30px')}</span> Insufficient Permissions</h1>
        <p>You might not have the necessary access rights or roles to view the content or perform the action. </p>
        <br /><br />
        <p>This is a restricted dashboard, Kindly consult your Coordinator to grant appropriate role to get access.</p>
        <p>
          For help, contact us at{" "}
          <a href={`mailto:${SUPPORT_EMAIL}?subject=Access Request ${path} &body=Please grant access ${path}`}>{SUPPORT_EMAIL}</a> {" "}or {" "}
          <a
                    role="button"
                    onKeyDown={handleKeyDown}
                    // tabIndex={0}
                    onClick={handleReportIssueClick}
                    style={{cursor:'pointer'}}
                  >
                     Report an issue
                  </a>
        </p>
        <p>
          <BackToHomeLink />
        </p>
        {showIncidentModal && (
        <ServiceNow open={showIncidentModal} handleClose={handleClose} />
      )}
      </Content>
    </Container>
  </Layout>

  
  )
}

export default PermissionsIssue;
